import { render, staticRenderFns } from "./VaFileUploadUndo.vue?vue&type=template&id=61bb4c8c&scoped=true&"
import script from "./VaFileUploadUndo.vue?vue&type=script&lang=js&"
export * from "./VaFileUploadUndo.vue?vue&type=script&lang=js&"
import style0 from "./VaFileUploadUndo.vue?vue&type=style&index=0&id=61bb4c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bb4c8c",
  null
  
)

export default component.exports